import LocalizationConstants from "../constants/localization-constants";
import { UnitOfMeasure } from "../models/Enums";

export type UnitTranslations = {
  lengthUnitTranslation: string;
  weightUnitTranslation: string;
};

export function getUnitTranslations(uow: UnitOfMeasure) {
  const isImperial = uow === UnitOfMeasure.Imperial;
  return {
    lengthUnitTranslation: isImperial
      ? LocalizationConstants.SHIPPING_PACKAGES_PACKAGE_FORM_IMPERIAL_IN
      : LocalizationConstants.SHIPPING_PACKAGES_PACKAGE_FORM_METRIC_CM,
    weightUnitTranslation: isImperial
      ? LocalizationConstants.SHIPPING_PACKAGES_PACKAGE_FORM_IMPERIAL_LB
      : LocalizationConstants.SHIPPING_PACKAGES_PACKAGE_FORM_METRIC_KG,
  };
}
